"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamValidator = void 0;
var _BaseValidator = require("../BaseValidator/BaseValidator");
var TeamValidator = exports.TeamValidator = {
  title: function title(v) {
    return v.length > 1 && v.length <= 100;
  },
  email: _BaseValidator.email,
  phone: _BaseValidator.phone
};